import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const Register = ({ onBackToLogin }) => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        university: '',
        title: '',
        phone: '',
        department: ''
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validation
        if (!formData.firstName || !formData.lastName || !formData.email || !formData.password) {
            setError('Please fill in all required fields (First Name, Last Name, Email, Password)');
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (formData.password.length < 6) {
            setError('Password must be at least 6 characters');
            return;
        }

        try {
            setLoading(true);

            const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://169.58.21.41/api';
            await axios.post(`${API_URL}/users/register`, {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                password: formData.password,
                university: formData.university || null,
                title: formData.title || null,
                phone: formData.phone || null,
                department: formData.department || null
            });

            setSuccess(true);
        } catch (err) {
            console.error('Registration error:', err);
            let msg = 'Registration failed';
            if (err.code === 'auth/email-already-in-use') msg = 'This email address is already in use';
            if (err.code === 'auth/weak-password') msg = 'Password is too weak';
            setError(err.response?.data?.error || msg);
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <div className="logo-section">
                            <h1>SWAMED</h1>
                        </div>
                    </div>
                    <div className="success-message">
                        <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
                        <h2>Registration Successful!</h2>
                        <p style={{ color: '#64748b', marginBottom: '30px' }}>
                            Your account has been created and is pending admin approval.
                        </p>
                        <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: '30px' }}>
                            You will be able to sign in once an administrator approves your account.
                        </p>
                        <button onClick={onBackToLogin} className="auth-button">
                            Back to Sign In
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-header">
                    <div className="logo-section">
                        <h1>SWAMED</h1>
                    </div>
                    <h2>Create New Account</h2>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {error && <div className="error-message">{error}</div>}

                    <div className="form-grid">
                        <div className="form-group">
                            <label>First Name <span className="required">*</span></label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                placeholder="Your first name"
                                disabled={loading}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Last Name <span className="required">*</span></label>
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                placeholder="Your last name"
                                disabled={loading}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Email <span className="required">*</span></label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="example@email.com"
                            disabled={loading}
                            required
                        />
                    </div>

                    <div className="form-grid">
                        <div className="form-group">
                            <label>Password <span className="required">*</span></label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="At least 6 characters"
                                disabled={loading}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Confirm Password <span className="required">*</span></label>
                            <input
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="Re-enter your password"
                                disabled={loading}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-divider">Optional Information</div>

                    <div className="form-group">
                        <label>University / Organization</label>
                        <input
                            type="text"
                            name="university"
                            value={formData.university}
                            onChange={handleChange}
                            placeholder="University or organization name"
                            disabled={loading}
                        />
                    </div>

                    <div className="form-grid">
                        <div className="form-group">
                            <label>Title</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="e.g. Dr., Prof., Researcher"
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label>Department</label>
                            <input
                                type="text"
                                name="department"
                                value={formData.department}
                                onChange={handleChange}
                                placeholder="Department name"
                                disabled={loading}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Phone</label>
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="+1 555 000 0000"
                            disabled={loading}
                        />
                    </div>

                    <button type="submit" className="auth-button" disabled={loading}>
                        {loading ? 'Creating Account...' : 'Create Account'}
                    </button>

                    <div className="auth-footer">
                        <p>
                            Already have an account?{' '}
                            <button type="button" onClick={onBackToLogin} className="link-button">
                                Sign In
                            </button>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Register;
